import request from '@/utils/httpRequest'

export function list(param) {
    return request({
        url: '/app/business/inspectioninfo/list',
        method: 'get',
        params: param
    })
}

export function save(data) {
    return request({
        url: '/app/business/inspectioninfo/save',
        method: 'post',
        data
    })
}

export function info(id) {
    return request({
        url: '/app/business/inspectioninfo/info/' + id,
        method: 'get'
    })
}

export function update(data) {
    return request({
        url: '/app/business/inspectioninfo/update',
        method: 'post',
        data
    })
}

export function probleminfo(probId) {
    return request({
        url: '/app/business/probleminfo/info/' + probId,
        method: 'get'
    })
}

export function updateClose(data) {
    return request({
        url: '/app/business/probleminfo/updateClose',
        method: 'post',
        data
    })
}
